import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOrderDetailsAction } from '../../actions';
import Layout from '../../components/Layout';
import Card from '../../components/UI/Card';
import { Breed } from '../../components/MaterialUI';
import { FaChevronCircleRight } from 'react-icons/fa';
import Price from '../../components/UI/Price';
import Spinner from '../../components/UI/Spinner';
import { formatDate, formatDate2, formatter, generatePublicUrl } from '../../HelperFunction';
import './style.css';

const OrderDetailsPage = (props) => {
	const dispatch = useDispatch();
	const orderDetails = useSelector((state) => state.user.orderDetails);
	// console.log(orderDetails);
	useEffect(() => {
		// console.log({ props });
		const payload = {
			orderId: props.match.params.orderId
		};
		// console.log(payload);
		dispatch(getOrderDetailsAction(payload));
	}, []);

	useEffect(() => {
		document.title = 'Détails de Commande - MimiShop';
	}, []);

	if (!(orderDetails && orderDetails.deliveryAddress)) {
		return <Layout><Spinner /></Layout>;
	}

	return (
		<Layout>
			<div
				style={{
					maxWidth: '1200px',
					margin: '30px auto'
				}}
			>
				<h3 className="textCenter m-5">Détailles de la Commande</h3>
				<Breed
					breed={[
						{
							name: 'Accueil',
							href: '/'
						},
						{
							name: 'Mon Compte',
							href: '/account/'
						},
						{
							name: 'Mes Commandes',
							href: '/account/orders'
						},
						{
							name: `${orderDetails._id}`,
							href: `/order_details/${orderDetails._id}`
						}
					]}
					breedIcon={<FaChevronCircleRight />}
				/>

				<Card
					style={{
						margin: '40px auto'
					}}
				>
					<div className="delAdrContainer sb">
						<div className="delAdrDetails">
							<div className="delTitle">
								Numéro de la Commande &nbsp; <FaChevronCircleRight /> &nbsp; {orderDetails._id}
							</div>
							<div className="stepCompleted">
								<div className="delAddress">
									<span>
										Frais de Livraison:{' '}
										{orderDetails.deliveryCharges ? (
											formatter.format(orderDetails.deliveryCharges)
										) : (
											'GRATUIT'
										)}
									</span>
								</div>
								<span />
								<Price
									fontSize="18px"
									title="Facture Totale"
									divider={<FaChevronCircleRight />}
									value={orderDetails.totalAmount}
								/>
							</div>
						</div>
						<div className="delAdrDetailsRight">
							<div className="delTitle">Paiement</div>
							<div className="paymentStatus">
								<span>Méthode: {orderDetails.paymentType}</span>
							</div>
							<div className="paymentStatus">
								<span>Status: {orderDetails.paymentStatus}</span>
							</div>
						</div>
					</div>
					<div className="delAdrContainer sb">
						<div className="delAdrDetails">
							<div className="delTitle">Addresse de Livraison</div>
							<div className="stepCompleted">
								<div className="delName">Destinataire: {orderDetails.deliveryAddress.name}</div>
								<div className="delAddress">Addresse: {orderDetails.deliveryAddress.streetAddress}</div>
								<div className="delPhoneNumber" />
								Numéro de Contact: {orderDetails.deliveryAddress.mobileNumber}
							</div>
						</div>
						<div className="delMoreActionContainer">
							<div className="delTitle">Autres Actions</div>
							<div className="delName stepCompleted">Télécharger le reçu</div>
						</div>
					</div>
				</Card>

				{orderDetails.items.map((item, index) => (
					<Card style={{ display: 'flex', padding: '20px', margin: '40px auto' }}>
						<div className="flexRow sb">
							<div style={{ flex: 2 }}>
								<div className="delItemImgContainer">
									<img
										src={generatePublicUrl(item.productId.productPictures[0].img)}
										alt={item.productId.productPictures[0].img}
									/>
								</div>
							</div>
							<div style={{ flex: 4}}>
								<div className="delItemInfoContainer">
									<div className="delItemName">{item.productId.name}</div>
									<div className="delItemPrice">
										<Price
											fontSize="15px"
											title={`Prix: ${item.purchasedQty}`}
											divider=" x "
											value={item.payablePrice}
										/>
									</div>
								</div>
							</div>

							{orderDetails.orderStatus && orderDetails.orderStatus.length > 3 && orderDetails.orderStatus[3].isCompleted && (
								<div style={{ flex: 1.8, fontWeight: '500', fontSize: 13 }}>
									{`Livraison éffectuée le ${formatDate2(orderDetails.orderStatus[3].date)}`}
								</div>
							)}
						</div>
						<div className="orderTrack">
							{orderDetails.orderStatus.map((status) => (
								<div className={`orderStatus ${status.isCompleted ? 'active' : ''}`}>
									<div className={`point ${status.isCompleted ? 'active' : ''}`} />
									<div className="orderInfo">
										<div className="status">{status.type}</div>
										<div className="date">{formatDate(status.date)}</div>
									</div>
								</div>
							))}
						</div>
					</Card>
				))}
			</div>
		</Layout>
	);
};

export default OrderDetailsPage;
